export default "__VITE_ASSET__3b582cac__"